import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { createEntity } from "../../api/entities/Entity";
import AddEntityForm from "../../components/Entities/AddEntityForm";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { setLoading } from "../../store/UI";
import { EntityForm } from "../../types/forms/entity";

const AddEntity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleError = useErrorHandler();

  const handleSaveAction = async (values: EntityForm) => {
    try {
      dispatch(setLoading(true));
      const response = await createEntity(values);
      navigate(`/entities/${response.id}`, { replace: true });
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div>
      <AddEntityForm onSubmit={handleSaveAction} />
    </div>
  );
};

export default AddEntity;